import React from 'react'
import styled from 'styled-components'

import { inactiveColor } from 'uiComponents/constants/colors'

interface IColorBubbleProps {
  color: string
  isLightColor: boolean
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>
}

const ColorBubble = styled.i<IColorBubbleProps>`
  background-color: ${({ color }) => color};
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid
    ${({ color, isLightColor }) => (isLightColor ? inactiveColor : color)};
  border-radius: 100%;
`

export default ColorBubble
